import { __ } from "@libs/utilities";
import { useDataStore } from "@/modules/pe-basic-module/data/store";
import { Button, Icon } from "@blueprintjs/core";
import { useRef } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { IPEFestSchool, IProject } from "../../data/interfaces";
import getSchoolUniqTutors from "../../data/utils/getSchoolUniqTutors";
import getSchoolUniqUsers from "../../data/utils/getSchoolUniqUsers";
import BackLink from "./BackLink";
import Switcher from "./Switcher";
import Table, { TABLE_THREAD_TYPE } from "src/libs/useful/table";
import { IFestStatistics, useFestStatistic } from "../../data/store";

/* Protopia Ecosystem component */
export interface ISchoolsFormProps { 
    goto: (url:string) => void
    members: IProject[] 
}
const SchoolsForm = (props: ISchoolsFormProps): JSX.Element => {
    const schools: IPEFestSchool[]  = useDataStore((state:any) => state.PEFestSchool) 
    const schoolRows                = useFestStatistic((state: IFestStatistics) => state.schoolRows)
    const contextMethods            = useFestStatistic((state: IFestStatistics) => state.contextMethods)

    const tableRef = useRef(null);
    const printIt = () => {
        const restorePage = $('body').html(); 
        $( "fest-header" ).hide()
        $( "fest-phase-labels" ).hide()
        $( "fest-head-switcher" ).hide()
        const printPage = $('body').html()
        $('body').empty().html( printPage )
        window.print();
        $('body').html(restorePage); 
    }
    return <div className=' w-100'>
        <div className='mt-0 mb-0 w-100'> 
            <div className='align-items-center w-100 d-flex justify-content-md-between justify-content-center flex-md-row flex-column'>
                <div className='flex-centered'>
                    <BackLink />
                    <Switcher goto={props.goto} url={"schools"}/>
                </div>
                <div className='flex-centered'>
                    <div className=' display-6 '>
                        { schools.length }
                    </div>
                    <Button variant="minimal" className='px-3 py-2 ml-3' onClick={printIt}>
                        <Icon icon="print" size={21} className="hint hint--top" data-hint={__("Print")} />
                    </Button> 
                    <DownloadTableExcel
                        filename="schools"
                        sheet="schools"
                        currentTableRef={ tableRef.current }
                    >
                        <Button variant="minimal" className='px-3 py-2 '>
                            <Icon 
                                icon="th" 
                                size={21} 
                                className="hint hint--top pointer" 
                                data-hint={__("Download XLS")}
                            />
                        </Button>                            
                    </DownloadTableExcel> 
                </div>
            </div> 
        </div>
        <Table
            rows={schoolRows}
            id="schoolRows"
            striped
            threadType={ TABLE_THREAD_TYPE.SECONDARY }
            className="pe-fest-table-statistics"
            data={ 
                schools.map((school, i) => {
                    return [
                        i + 1,
                        school.title,
                        school.guardian?.display_name,
                        school.guardian2?.display_name,
                        getSchoolUniqUsers( school.id,  props.members ).length,
                        getSchoolUniqTutors( school.id,  props.members ).length,
                        school.count,
                    ]
                }).flat()
            } 
            ref={ tableRef }
        /> 
        {/* <table 
            className='table table-striped table-bordered2 table-hover1 pe-fest-table-statistics w-100 mt-0' 
            id="members-to-xls"
            ref={ tableRef }
        >
        `   <thead className="thead-dark-33 bg-secondary text-white">    
                <tr>
                    <th scope="col" style={{ width: 55 }} >
                        {__("#")}
                    </th>
                    <th scope="col" >
                        {__("School")}
                    </th>
                    <th scope="expert">
                        {__("Guardian")}
                    </th>
                    <th scope="col"  >
                        {__("Guardian 2")}
                    </th> 
                    <th scope="col"  >
                        {__("Projects's members")}
                    </th> 
                    <th scope="col"  >
                        {__("Projects's tutors")}
                    </th> 
                    <th scope="col"  style={{ width: 80 }}  >
                        {__("Projects count")}
                    </th> 
                </tr>                
            </thead >
            <tbody>
                {
                    schools.map((school, i) => <tr key={school.id}>
                        <td>{i + 1}</td>
                        <td>
                            { school.title }
                        </td>
                        <td>
                            { school.guardian?.display_name }
                        </td>
                        <td>
                            { school.guardian2?.display_name }
                        </td>
                        <td>
                            { getSchoolUniqUsers( school.id,  props.members ).length }
                        </td>
                        <td>
                            { getSchoolUniqTutors( school.id,  props.members ).length }
                        </td>
                        <td>
                            { school.count }
                        </td>
                    </tr>)
                }
            </tbody>`
        </table> */}
    </div>
}
export default SchoolsForm